export default {
  menu: {
    header: {
      games: 'GAMES',
      userInfo: 'USER INFO'
    },
    nextGame: {
      title: 'NEXT GAME',
      description: '予約の確認'
    },
    history: {
      title: 'HISTORY',
      description: 'プレイ履歴・謎の解答'
    },
    profile: {
      title: 'PROFILE',
      description: 'プロフィールの確認'
    },
    orders: {
      title: 'ORDERS',
      description: 'ご注文情報の確認'
    },
    payment: {
      title: 'PAYMENT',
      description: 'お支払い情報の確認'
    },
    login: {
      title: 'LOG IN',
      description: 'ログイン'
    },
    logout: {
      title: 'LOG OUT',
      description: 'ログアウト'
    },
    contact: {
      title: 'CONTACT',
      description: 'お問い合わせ'
    },
    faq: {
      title: 'FAQ',
      description: 'よくある質問'
    },
    game0: {
      title: 'サラと謎のハッカークラブ 第1弾'
    },
    game1: {
      title: 'サラと謎のハッカークラブ 第2弾'
    },
    game3: {
      title: 'PSYCHO-PASS サイコパス 渋谷サイコハザード'
    },
    game6: {
      title: '#コンパスAR謎解き Mystery of Mirage Message'
    }
  }
};
